import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { Typography } from "@mui/material";

import { mstrPath } from "../../../utils/mstrBase";

const DynamicAlert = ({ error, resetErrorBoundary }) => {
  const history = useHistory();

  const [open, setOpen] = React.useState(true);
  const handleClose = (event, reason) => {
    resetErrorBoundary();
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (error?.action === "redirection") {
      history.push(mstrPath(`error?type=${error.id}`));
    }
  });

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert ref={ref} elevation={6} variant="filled" {...props} />;
  });

  // Normalize: error may arrive as a plain string (e.g. e.message from a catch),
  // and never mutate the prop object directly.
  const normalizedError =
    typeof error === "string" ? { message: error } : { ...(error || {}) };

  if (normalizedError.severity === undefined) {
    normalizedError.severity = "warning";
  }

  if (!normalizedError.message) {
    normalizedError.message = "Generic error in the application";
  }

  return (
    <Snackbar
      autoHideDuration={1000 * 5}
      open={open}
      sx={{ bottom: "50px", zIndex: 20000 }}
      onClose={handleClose}
    >
      <Alert severity={normalizedError.severity} sx={{ width: "100%" }} onClose={handleClose}>
        <Typography sx={{ fontSize: "12px" }}>{normalizedError.message}</Typography>
        <Typography sx={{ fontSize: "10px" }}>
          {normalizedError.action?.mstrRestAPIErrorResponse?.message || normalizedError.action?.details}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default DynamicAlert;
